// Current currency configuration
window.shopCurrency = Shopify.currency.active;
window.currentCurrency = Shopify.currency.active;

// Ensure prices are displayed in the correct currency
document.addEventListener('DOMContentLoaded', function() {
  if (window.shopCurrency !== window.currentCurrency) {
    updatePrices();
  }

  // Listen to all currency selectors
  const currencySelectors = document.querySelectorAll('[data-currency-selector]');
  currencySelectors.forEach(selector => {
    selector.addEventListener('change', function(e) {
      e.preventDefault();
      window.currentCurrency = this.value;
      
      // If selector has data-form-submit attribute, submit the form
      if (this.hasAttribute('data-form-submit')) {
        const form = this.closest('form');
        if (form) {
          const scrollPosition = window.scrollY;
          const scrollInput = form.querySelector('[data-scroll-position]');
          if (scrollInput) {
            scrollInput.value = `${scrollInput.value}#scroll=${scrollPosition}`;
          }
          form.submit();
        }
      } else {
        // Only update prices without reloading the page
        updatePrices();
      }
    });
  });
});

function updatePrices() {
  // Actualizar precios generales
  const priceElements = document.querySelectorAll('[data-price]');
  priceElements.forEach(element => {
    const originalPrice = element.getAttribute('data-original-price');
    if (originalPrice) {
      element.innerHTML = formatMoney(originalPrice);
    }
  });

  // Actualizar carrito si existe
  if (window.SimpleCart?.instance) {
    window.SimpleCart.instance.refreshCart();
  } else {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
}

// Format money - delegates to ThemeUtils when available
function formatMoney(cents) {
  if (window.ThemeUtils?.formatMoney) {
    return window.ThemeUtils.formatMoney(cents);
  }
  return (cents / 100).toLocaleString(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active,
    minimumFractionDigits: 2
  });
}

window.formatMoney = formatMoney;